<template>
  <div class="formulaire">
    <h3>Obtenir mes coordonnées / Get my contact details</h3>
    <div v-if="errorMessage" class="message error">{{ errorMessage }}</div>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="codeAcces">Code d'accès / Access code
          <input type="text" id="codeAcces" v-model="codeAcces" :disabled="loading" required>
        </label>
      </div>
      <div class="form-group">
        <label for="codeEmail">Code e-mail / Email code
          <input type="text" id="codeEmail" v-model="codeEmail" :disabled="loading" required>
        </label>
      </div>
      <div class="form-actions">
        <button type="submit" :disabled="loading">
          <span v-if="loading" class="spinner" />
          <span v-else>Valider / Commit</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useMentionsLegalesStore from '@/stores/mentionsLegales';

interface ComponentData {
  codeAcces: string;
  codeEmail: string;
  errorMessage: string;
  loading: boolean;
  store: ReturnType<typeof useMentionsLegalesStore>;
}

export default defineComponent({
  name: 'MentionsLegalesForm2',

  data(): ComponentData {
    return {
      codeAcces: '',
      codeEmail: '',
      errorMessage: '',
      loading: false,
      store: useMentionsLegalesStore(),
    };
  },

  methods: {
    async submitForm() {
      this.errorMessage = '';
      this.loading = true;
      try {
        const response = await fetch('/api/mentions_legales_2', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            codeAcces: this.codeAcces,
            codeEmail: this.codeEmail,
            token: this.store.token,
          }),
        });
        const result = await response.json();
        if (result.status === 'ok') {
          this.store.setDetail(result.detail);
          this.$emit('change-etape', 'Resultat');
        } else {
          this.errorMessage = result.message || this.$t('errors.generic');
          // eslint-disable-next-line no-console
          console.error('API error:', { httpStatus: response.status, status: result.status, body: result });
        }
      } catch (error) {
        this.errorMessage = this.$t('errors.generic');
        // eslint-disable-next-line no-console
        console.error('Network error:', { error });
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
